import apiV2 from "api-v2";

interface QuoteRowRequest {
	inviteId: number;
	quoteId: number;
}

export interface SupplierRowData {
	id: number;
	uuid: string | null;
	name: string;
	unit_id: number | null;
	sort_order: number;
	created_by_type: "client" | "supplier";
}

interface CreateSupplierRowPayload {
	name: string;
	unit_id: number | null;
}

interface UpdateSupplierRowPayload {
	name?: string;
	unit_id?: number | null;
}

export const getSupplierRows = async (
	request: QuoteRowRequest
): Promise<SupplierRowData[]> => {
	const response = await apiV2.get<{ data: SupplierRowData[] }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows`
	);
	return response.data.data;
};

export const createSupplierRow = async (
	request: QuoteRowRequest,
	payload: CreateSupplierRowPayload
): Promise<SupplierRowData> => {
	const response = await apiV2.post<{ data: SupplierRowData }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows`,
		payload
	);
	return response.data.data;
};

export const updateSupplierRow = async (
	request: QuoteRowRequest,
	rowId: number,
	payload: UpdateSupplierRowPayload
): Promise<SupplierRowData> => {
	const response = await apiV2.put<{ data: SupplierRowData }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows/${rowId}`,
		payload
	);
	return response.data.data;
};

export const deleteSupplierRow = async (
	request: QuoteRowRequest,
	rowId: number
): Promise<void> => {
	await apiV2.delete(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows/${rowId}`
	);
};
